export default "/img/logo-22seven.png"